import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { HvGrid, HvTypography } from "@hitachivantara/uikit-react-core";

import Container from "components/layout/Container";
import MembersSettingsTable from "components/membersSettings/MemberSettingsTable";
import { ModuleNames, ModulePolicyTypes } from "lib/api/userSettings";
import { UserDataContext } from "lib/context/UserDataContext";
import NotFound from "components/common/NotFound";

const Users: React.FC = () => {
  const { t } = useTranslation("users");

  return (
    <Container>
      <HvGrid container>
        <HvGrid item xs={12}>
          <HvTypography variant="mTitle" component="h1">
            {t("title")}
          </HvTypography>
        </HvGrid>
        <HvGrid item xs={12}>
          <MembersSettingsTable />
        </HvGrid>
      </HvGrid>
    </Container>
  );
};
export const UsersAuth: React.FC = () => {
  const { hasModulePolicy } = useContext(UserDataContext);
  const hasRight = useMemo(() => {
    return hasModulePolicy(ModuleNames.core, ModulePolicyTypes.usergroupsAdmin);
  }, [hasModulePolicy]);
  return (
    <>
      {hasRight ? (
        <Container noHVContainer>
          <Users />
        </Container>
      ) : (
        <NotFound />
      )}
    </>
  );
};
export default Users;
